/**
 * System Template Management - Platform admin interface for managing system templates
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminPageLayout, Section } from '../../components';
import {
  Listing,
  ListingActionBar,
  ListingCard
} from '../../components/listing/v2';
import {
  ShieldCheck,
  Zap,
  Target,
  FileText,
  ChevronRight
} from 'lucide-react';

const TEMPLATE_TYPES = [
  {
    value: 'role',
    label: 'ROLE ARCHITECTURE',
    description: 'Standardized staff authority profiles and administrative logic.',
    icon: <ShieldCheck size={40} />,
    path: '/admin/role-templates'
  },
  {
    value: 'skill',
    label: 'ASSESSMENT ARCHITECTURE',
    description: 'Universal performance evaluation schemas and competency metrics.',
    icon: <Target size={40} />,
    path: '/admin/skill-templates'
  },
  {
    value: 'training_objective',
    label: 'TRAINING CURRICULUM',
    description: 'System-level activity and session templates (reference library for clubs).',
    icon: <Zap size={40} />,
    path: '/admin/system-templates/curriculum'
  },
  {
    value: 'document',
    label: 'DOCUMENTS',
    description: 'Compliance frameworks, waivers, and legal requirements.',
    icon: <FileText size={40} />,
    path: '/admin/platform/document-templates'
  }
];

const SystemTemplateManagement = () => {
  const navigate = useNavigate();

  return (
    <AdminPageLayout
      title="SYSTEM TEMPLATES"
      subtitle="Configure and manage global organization templates"
      backPath="/admin/platform"
      maxWidth="1400px"
    >
      <Section title="CORE SYSTEM FRAMEWORKS">
        <Listing
          items={TEMPLATE_TYPES}
          variant="grid"
          renderItem={(item) => (
            <ListingCard
              key={item.value}
              title={item.label}
              subtitle={item.description}
              icon={item.icon}
              variant="admin"
              iconVariant="admin"
              size="medium"
              level={1}
              onClick={() => navigate(item.path)}
              actions={<ChevronRight size={20} style={{ opacity: 0.5 }} />}
            />
          )}
        />
      </Section>
    </AdminPageLayout>
  );
};

export default SystemTemplateManagement;
